export { default as AnnouncementBannerDumb } from './announcement-banner-dumb';
